import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography/index';
import ListItem from '@material-ui/core/ListItem/index';
import { Icon } from './styles';

const YoutubeItem = props => {

    const { suggestion } = props

    return (
        <ListItem button onClick={() => props.handleSelected(suggestion)}>
            <Icon alt="icon" src={suggestion.image} />
            <div>
                <Typography>{suggestion.title}</Typography>
                <Typography variant="body2">{suggestion.subtitle}</Typography>
            </div>
        </ListItem>
    );
}

YoutubeItem.propTypes = {
    suggestion: PropTypes.object.isRequired,
    handleSelected: PropTypes.func
}

export default YoutubeItem
